/**
 * Service pour les opérations sur les formations
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const formationsService = {
  list: () => api.get(endpoints.formations.list()),

  getCategories: () => api.get(endpoints.formations.categoriesDistinct()),

  getMessages: () => api.get('/api/public/formation-messages/public/messages')
}
